import { getPfmInstance } from '@shared/api';

export const TownFromAPI = {
  townFromQueryKey: () => ['town-from-query'],
  getTownFrom() {
    const pfm = getPfmInstance();

    return pfm.tourflow.getTownsFrom();
  },
};
